var map = {
	"./ADME Prediction.svg": 69053,
	"./Affinity Prediction.svg": 99670,
	"./Antibody Develoipability.svg": 72631,
	"./Atom Network.svg": 66754,
	"./Biology Networks.svg": 737,
	"./Drug Generation.svg": 81109,
	"./Heredity.svg": 54409,
	"./Joint Injury.svg": 35418,
	"./Molecular Interaction.svg": 34635,
	"./Multi-Omics Analytics.svg": 86814,
	"./Mutation Intelligence.svg": 72991,
	"./Obesity.svg": 61684,
	"./Progress Prediction.svg": 7893,
	"./Protein Function.svg": 53216,
	"./Protein Structure.svg": 52551,
	"./age.svg": 61844,
	"./ai_chip.svg": 96606,
	"./alarm.svg": 63630,
	"./analysis.svg": 7593,
	"./assist.svg": 22978,
	"./bags.svg": 7434,
	"./book.svg": 83952,
	"./cart.svg": 48005,
	"./ch.svg": 58402,
	"./checklist.svg": 66325,
	"./computer.svg": 88288,
	"./conversation.svg": 79002,
	"./cowboy.svg": 35834,
	"./customerSupport.svg": 42004,
	"./discuss.svg": 7123,
	"./dna.svg": 7414,
	"./doctor.svg": 9078,
	"./gene report.svg": 59902,
	"./head.svg": 53721,
	"./hk.svg": 49084,
	"./info.svg": 81271,
	"./joint.svg": 86813,
	"./jp.svg": 68349,
	"./like.svg": 22186,
	"./navigation.svg": 97497,
	"./network.svg": 45191,
	"./pamplet.svg": 49016,
	"./payement_integration.svg": 48111,
	"./payment.svg": 82099,
	"./pill.svg": 48054,
	"./privacy.svg": 8749,
	"./query.svg": 40553,
	"./question.svg": 91767,
	"./sing.svg": 61218,
	"./tw.svg": 36324,
	"./us.svg": 88091,
	"./world.svg": 83017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19095;